var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.open)?_c('div',{class:['overlay', _vm.local ? 'overlay-absolute' : 'overlay-fixed']},[_c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"loader"}),_c('p',{staticClass:"loader-text"},[_vm._v(_vm._s(_vm.text))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }